import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  
  const routeMap = {
    '/homepage': { label: 'Home', icon: 'Home' },
    '/services-overview': { label: 'Services', icon: 'Briefcase' },
    '/individual-service-detail': { label: 'Service Details', icon: 'FileText', parent: '/services-overview' },
    '/about-us': { label: 'About Us', icon: 'Building2' },
    '/team-profiles': { label: 'Our Team', icon: 'Users' },
    '/contact-consultation-request': { label: 'Contact', icon: 'MessageSquare' }
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;
    
    const currentRoute = routeMap[location.pathname];
    if (!currentRoute) return [];

    const breadcrumbs = [{ label: 'Home', path: '/homepage', icon: 'Home' }];
    
    if (location.pathname !== '/homepage') {
      if (currentRoute.parent) {
        const parentRoute = routeMap[currentRoute.parent];
        if (parentRoute) {
          breadcrumbs.push({
            label: parentRoute.label,
            path: currentRoute.parent,
            icon: parentRoute.icon
          });
        }
      }
      
      breadcrumbs.push({
        label: currentRoute.label,
        path: location.pathname,
        icon: currentRoute.icon,
        current: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs.map((item, index) => (
          <li key={item.path || index} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="mx-2 text-border" 
              />
            )}
            
            {item.current ? (
              <span className="flex items-center space-x-1.5 text-foreground font-medium">
                <Icon name={item.icon} size={16} />
                <span>{item.label}</span>
              </span>
            ) : (
              <Link
                to={item.path}
                className="flex items-center space-x-1.5 hover:text-primary transition-smooth"
              >
                <Icon name={item.icon} size={16} />
                <span>{item.label}</span>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;